export default __webpack_public_path__ + "f710f3ea303ee1809080fdbd332fd05d.png";